module.exports = __webpack_public_path__ + "img/Logo-16.0c0a5866.svg";